<div class="impersonation-banner" role="status">
  <div class="impersonation-banner__message">
    <rs-web-icon [icon]="icons.User" [size]="14"></rs-web-icon>
    <span class="impersonation-banner__text im:body">{{
      'impersonation.read_only_banner_l' | translate
    }}</span>
  </div>
  @if (countdown(); as countdown) {
    <div class="impersonation-banner__timer">
      <rs-web-icon [icon]="icons.Clock" [size]="12"></rs-web-icon>
      <span class="impersonation-banner__text im:body">{{ countdown }}</span>
    </div>
  }
</div>
